import React, { useState } from 'react';
import {
    ParentalControlDefaultButton,
    ParentalControlDefaultButtons,
    ParentalControlDefaultCheckMark,
    ParentalControlDefaultInput,
    ParentalControlDefaultInputWrapper,
    ParentalControlDefaultLabel,
} from './ParentalControl.styles.js';
import Link from 'next/link';

const ParentalControlDefault = ({ settingsUrl, onPlay }) => {
    const [isChecked, setIsChecked] = useState(false);

    return (
        <>
            <ParentalControlDefaultLabel
                htmlFor="accept_inappropriate_content"
                data-rt="video-player-parental-agree"
            >
                <ParentalControlDefaultInputWrapper>
                    <ParentalControlDefaultInput
                        name="accept_inappropriate_content"
                        id="accept_inappropriate_content"
                        value="yes"
                        onChange={() => setIsChecked(!isChecked)}
                    />
                    <ParentalControlDefaultCheckMark isChecked={isChecked} />
                    Jag förstår
                </ParentalControlDefaultInputWrapper>
            </ParentalControlDefaultLabel>
            <ParentalControlDefaultButtons>
                <ParentalControlDefaultButton
                    type="button"
                    onClick={onPlay}
                    isDisabled={!isChecked}
                    data-rt="video-player-parental-splash-play"
                    disabled={!isChecked}
                >
                    Spela programmet
                </ParentalControlDefaultButton>
                <Link href={settingsUrl} passHref>
                    <ParentalControlDefaultButton as="a">
                        Förstärk barnskyddet med kod
                    </ParentalControlDefaultButton>
                </Link>
            </ParentalControlDefaultButtons>
        </>
    );
};

export default ParentalControlDefault;
